<div class="card success" *ngIf="success">
  <ax-icon class="icon" name="check"></ax-icon>
  <span>{{ 'agreement.verification.success.message' | translate }}</span>
</div>

@if (!_verified) {
  <div class="message">
    <ax-icon class="icon snackbar-icon" name="alert"></ax-icon>

    @if (!resendSuccessful) {
      <span
        [innerHTML]="
          'agreement.verification.snackbar.message'
            | translate
              : {
                  verificationType:
                    ('agreement.verification.type.' + proposal?.verification
                    | translate
                    | lowercase),
                  verificationValue: verificationValue,
                  minutes: resendMinutes && resendMinutes > 0 ? resendMinutes : 20
                }
        "
      ></span>
    } @else if (resendSuccessful) {
      <span
        [innerHTML]="
          'agreement.verification.resend.success'
            | translate
              : {
                  verificationValue: this.verificationValue,
                  minutes: resendMinutes && resendMinutes > 0 ? resendMinutes : 20
                }
        "
      ></span>
    }
  </div>

  <div class="card">
    <ax-otp-verification
      [verificationValue]="verificationValue"
      [verificationType]="proposal?.verification === 'MOBILE' ? 'MOBILE' : 'EMAIL'"
      [verification]="verification"
      [retryVerification]="retryVerification"
      [canChangeValue]="!language?.verificationRequestedPropertyId"
      [verificationCode]="verificationCode"
      [startDate]="verificationAttemptTimestamp"
      [autoVerification]="autoVerification"
      (verificationValueChanges)="verificationValue = $event"
      (verificationComplete)="verificationComplete($event)"
    ></ax-otp-verification>
  </div>
}
